/* QUADRO R8: shared responsive image updates for PDPs and collection cards. */
(() => {
  'use strict';
  if (window.QuadroProductMedia) return;
  const widths = [180, 240, 360, 480, 520, 640, 750, 900, 1080, 1200, 1500, 1800];
  const canonical = value => {
    try { return new URL(value, document.baseURI).href; } catch (_) { return ''; }
  };
  const set = (element, name, value) => {
    value = String(value);
    if (element.getAttribute(name) !== value) element.setAttribute(name, value);
  };
  function update(image, variant) {
    if (!image || !variant || !variant.image) return;
    const isResponsive = image.hasAttribute('data-quadro-image');
    const url = canonical(variant.image);
    if (!url) return;
    const sameId = variant.imageId != null && String(variant.imageId) === image.dataset.quadroImageId;
    const sameUrl = canonical(image.getAttribute('src')) === url;
    // A matching initial PDP image is already correct: do not rewrite src/srcset.
    if (!isResponsive || (!sameId && !sameUrl)) {
      if (isResponsive) {
        const sourceWidth = Number(variant.imageWidth) || Number(image.dataset.quadroImageWidth) || 1800;
        const limit = Math.min(sourceWidth, image.dataset.quadroImageKind === 'detail' ? 1800 : 1200);
        const candidates = [...widths.filter(width => width < limit), limit];
        const srcset = candidates.map(width => {
          const candidate = new URL(url);
          candidate.searchParams.set('width', String(width));
          return `${candidate.href} ${width}w`;
        }).join(',');
        // Sizes stays tied to the layout, not to the selected color. Set srcset
        // before src; detached card images make only the final request on mount.
        set(image, 'srcset', srcset);
        if (variant.imageWidth > 0) set(image, 'width', variant.imageWidth);
        if (variant.imageHeight > 0) set(image, 'height', variant.imageHeight);
        if (variant.imageWidth > 0) set(image, 'data-quadro-image-width', variant.imageWidth);
        set(image, 'data-quadro-image-max', limit);
        if (variant.imageId != null) set(image, 'data-quadro-image-id', variant.imageId);
      }
      if (!sameUrl) set(image, 'src', variant.image);
    }
    set(image, 'alt', variant.imageAlt || '');
  }
  function mount(root, variant) {
    let image = root.querySelector('[data-product-image]');
    if (image) return image;
    const template = root.querySelector('template[data-quadro-card-image]');
    const source = template?.content?.querySelector('[data-product-image]');
    if (!source) return null;
    image = source.cloneNode(true);
    update(image, variant);
    template.replaceWith(image);
    return image;
  }
  function fallback(root = document) {
    root.querySelectorAll('template[data-quadro-card-image]').forEach(template => {
      // Controller did not initialise (e.g. malformed JSON or failed asset):
      // preserve SSR selection and show its image, rather than an empty card.
      const source = template.content.querySelector('[data-product-image]');
      if (source) template.replaceWith(source.cloneNode(true));
    });
  }
  window.QuadroProductMedia = { update, mount };
  const scheduleFallback = root => setTimeout(() => fallback(root), 0);
  if (document.readyState !== 'complete') {
    document.addEventListener('DOMContentLoaded', () => scheduleFallback(document), { once: true });
  } else scheduleFallback(document);
  document.addEventListener('shopify:section:load', event => scheduleFallback(event.target));
})();
